export const SELF_ID = {
  prompt: "Before we start, which of these sounds most like your organisation today?",
  reassure: "There's no right answer. It just helps us read your results in context.",
  options: [
    { id: "evaluator", text: "We're still working out what AI could do for us before we commit to anything." },
    { id: "experimenter", text: "There's lots of AI activity and enthusiasm, but it's scattered and hard to point to results." },
    { id: "stalled", text: "We've invested in AI tools, but we're not getting much from them yet." },
    { id: "quiet", text: "We run a tight ship, but AI hasn't really been a deliberate priority for us." },
    { id: "primed", text: "We know what we want from AI and we're ready, we just haven't really started." },
    { id: "scaler", text: "AI is well established here and delivering real value, we're focused on doing it well at scale." },
    { id: "regrouper", text: "We've tried AI, learned some hard lessons, and we're deliberately regrouping before the next push." },
    { id: "none", text: "None of these quite fit." },
  ],
};
